<template>
  <div class="all-whole">
    <navCom :navActive="navActive"></navCom>
    <div class="w clearfix" >
      <!--左侧导航 start-->
      <user-nav :userNav="userNav"></user-nav>
      <!--左侧导航 end-->
      <!--右侧内容 start-->
      <div  class="user-main-right">
        <h3 class="info-title">我的直播课</h3>
        <ul class="timetable-list">
          <li @click="listDetailFun(item.course_id)" v-for="item in course_list">
            <div class="timetable-list-item-top">
              <span>课程编号：{{item.course_info.course_num}}</span>
            </div>
            <div class="timetable-list-item-bottom">
              <div class="name">
                <span><img :src="item.course_info.course_pic" :onerror="errorImg01" width="100%" height="100%"></span>
                <div class="timetable-txt">
                  <h3>{{item.course_info.course_name}}</h3>
                  <p>直播课</p>
                </div>
              </div>

              <div class="time">
<!--                <span>共{{item.total_video_num}}个视频</span>-->
                <span>{{item.course_info.live_start_time}}至{{item.course_info.live_end_time}}</span>
              </div>

              <div class="status">
                <p class="look-time-txt">{{item.course_info.status}}</p>
              </div>

              <div class="teacher">
                <span class="teacher-img"><img :src="item.teacher_info.teacher_pic" width="100%" height="100%"></span>
                <p class="teacher-txt">教师：{{item.teacher_info.teacher_name}}</p>
              </div>
            </div>
          </li>
        </ul>
        <!-- 分页 start-->
        <page-com :last_page="last_page" :total="total" @pagechange="getLive" :display='display' :current-page='current_page' v-if="course_list.length > 0" ></page-com>
        <!-- 分页 end-->
        <!--    <no-data v-if="noDataFlag == 1"></no-data>-->
        <!--    <div v-if="noDataFlag == 1">555555555555</div>-->
      </div>
      <!--右侧内容 end-->
    </div>
    <footerCom></footerCom>
  </div>
</template>

<script>
  import UserNav from '.././components/user-nav.vue'
  import pageCom from '.././components/page-com'
  import navCom from '../../components/welcome-nav'
  import footerCom from '../../components/foot'
  import tool from '../../assets/tjs/tool'
  import Livedetail from './user-live-detail'
  import userDown from './user-down'
  export default {
    name: "user-Liveclass",
    data(){
      return{
        errorImg01:'this.src="' + require('../../../static/images/zmr-images/default.jpg') + '"',
        navActive:3,
        userNav:5,
        total: 30,     // 记录总条数
        display: 3,   // 每页显示条数
        current_page:1,   // 当前的页数
        last_page:5,//总页数
        courses:[],//线下课列表
        noDataFlag:0,//无数据标识 0:有数据 1无数据
        course_info:Object,//课程信息
        course_list:Array,//课程循环
        teacher_info:Object,//教师信息
      }
    },
    components:{
      pageCom,
      UserNav,
      navCom,
      footerCom
    },
    methods: {
      getLive(currentPage){
        let data ={
          user_id:this.$store.state.uuid,
          type:1,
          page:currentPage
        };
        tool.postData('Center_My_Course/index', data, (res)=>{
          this.course_list=res.data.data;
          this.teacher_info=res.data.data.teacher_info;
          this.course_info=res.data.data.course_info;
          this.total = Number(res.data.total);
          this.display=Number(res.data.per_page);
          this.last_page=Number(res.data.last_page);
          this.current_page = Number(res.data.current_page);
          if(res.data.data.length > 0){
            this.noDataFlag = 0;
          }else{
            this.noDataFlag = 1;
          }
        })
      },
      listDetailFun (course_id) {
        this.$router.push({
          name: 'user-Livedetail',
          component: Livedetail,
          query: {
            course_id: course_id
          }
        });
      },
      downFun() {
        this.$router.push({
          name: 'user-down',
          component: userDown,
        });
      }
    },
    mounted(){
      this.getLive()
    }
  }
</script>

<style scoped>
  .w{
    width: 1200px;
    margin: 0 auto ;
  }
  .fl{
    float: left;
  }
  .fr{
    float: right;
  }
  .all-whole{
    background: #fbfbfb;
  }
  .user-main-right{
    width: 1000px;
    float: right;
    height: 896px;
    background: #ffffff;
  }
  .info-title {
    width: 100%;
    height: 70px;
    line-height: 100px;
    box-sizing: border-box;
    border-bottom: 1px solid #e3e3e3;
    color: #252525;
    padding-left: 20px;
    padding-right: 20px;
    font-weight: 500;
    display: flex;
    justify-content: space-between;
    font-size: 16px;
  }
  .timetable-list{
    margin-top: 30px;
  }
  .timetable-list li{
    border: 1px solid #e3e3e3;
    cursor: pointer;
    width: 954px;
    height: 213px;
    margin: 0 auto 26px;
  }
  .timetable-list-item-top{
    width: 100%;
    background: #f3f3f3;
    height: 48px;
    border-bottom: 1px solid #e3e3e3;
    padding: 0 15px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
  }
  .timetable-list-item-top span{
    font-size: 16px;
    color: #3a3a3a;
    font-weight: 500;
    line-height: 48px;
  }
  .timetable-list-item-top span:last-child{
    text-align: right;
  }
  .timetable-list-item-bottom{
    font-size: 0;
  }
  .timetable-list-item-bottom .name{
    width: 350px;
    height: 165px;
    display: inline-block;
    padding: 28px 15px;
    box-sizing: border-box;
    border-right: 1px solid #e3e3e3;
    vertical-align: top;
    position: relative;
  }
  .timetable-list-item-bottom .name span{
    width: 99px;
    height: 99px;
    display: inline-block;
  }
  .timetable-txt{
    display: inline-block;
    vertical-align: top;
    margin-left: 15px;
  }
  .timetable-txt h3{
    color: #414141;
    font-size: 20px;
    font-weight: normal;
    line-height: 36px;
    margin-bottom: 15px;
    width: 200px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .timetable-txt p{
    font-size: 16px;
    color: #8c8c8c;
  }

  .timetable-list-item-bottom .time{
    width: 216px;
    height: 165px;
    line-height: 165px;
    display: inline-block;
    border-right: 1px solid #e3e3e3;
    vertical-align: top;
    box-sizing: border-box;
    text-align: center;
    overflow: auto
  }
  .timetable-list-item-bottom .time span{
    color: #8c8c8c;
    font-size: 16px;
    line-height: 40px;
    vertical-align: middle;
    display: inline-block;
  }

  .timetable-list-item-bottom .status{
    width: 220px;
    height: 165px;
    display: inline-block;
    text-align: center;
    border-right: 1px solid #e3e3e3;
    vertical-align: top;
  }
  .timetable-list-item-bottom .status p{
    font-size: 16px;
    line-height: 165px;
  }
  .look-time-txt{
    color: #1a71ff;
    font-size: 16px;
    text-align: center;
    margin-bottom: 18px;
  }

  .timetable-list-item-bottom .teacher{
    width: 158px;
    height: 165px;
    display: inline-block;
    padding: 30px 0;
    box-sizing: border-box;
    text-align: center;
    vertical-align: top;
  }
  .teacher-img{
    width: 47px;
    height: 47px;
    border-radius: 50%;
    overflow: hidden;
    display: block;
    margin: 10px auto 0;
  }
  .teacher-txt{
    font-size: 16px;
    color: #8c8c8c;
    margin-top: 17px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/user-Liveclass.vue